module.exports = __webpack_public_path__ + "static/media/moneta@2x.3c80657f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-methods/moneta@2x.png
// module id = 606
// module chunks = 9